import PropertyPayment from "../payments-emi/PropertyPayment";
import TenantRentalDetails from "../../../components/TenantHome/TenantRentalDetails";

const TenantRentalPage = () => {
  return (
    <div className="main-page-wrapper" style={{paddingTop: "0.714vw"}}>
      <div>
        <TenantRentalDetails showBig={true} paySectionOnTop={true}/>
      </div>
      <div>
        <PropertyPayment />
      </div>
    </div>
  );
};

export default TenantRentalPage;
